export const getTimesConfig = ($datePicker, isToday, today) => {
  const allOptions = [
    { label: 'Select...', value: '' },
    { label: '9:00 am - 10:00 am ', value: '9:00am-10:00am' },
    { label: '10:00 am - 11:00 am ', value: '10:00am-11:00am' },
    { label: '11:00 am - 12:00 pm', value: '11:00am-12:00pm' },
    { label: '12:00 pm - 1:00 pm', value: '12:00pm-1:00pm' },
    { label: '1:00 pm - 2:00 pm', value: '1:00pm-2:00pm' },
    { label: '2:00 pm - 3:00 pm', value: '2:00pm-3:00pm' },
    { label: '3:00 pm - 4:00 pm', value: '3:00pm-4:00pm' },
    { label: '4:00 pm - 5:00 pm', value: '4:00pm-5:00pm' },
    { label: '5:00 pm - 6:00 pm', value: '5:00pm-6:00pm' }
  ];

  let parsedOptions = allOptions,
    minDatePicker = new Date()
      .toLocaleString('sv', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .split(' ')[0]
      .split('/')
      .reverse()
      .join('-');

  const hour = Number(
    new Date()
      .toLocaleTimeString('en-US', {
        timeZone: 'America/New_York',
        hour: '2-digit',
        hour12: false
      })
      .split(' ')[0]
  );
  const minutes = Number(
    new Date().toLocaleTimeString('en-US', {
      timeZone: 'America/New_York',
      minute: '2-digit'
    })
  );

  if (
    ((hour === 6 && minutes >= 1) || (hour === 7 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (index === 1) return false;
      return true;
    });
  } else if (
    ((hour === 7 && minutes >= 1) || (hour === 8 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (index === 1 || index === 2) return false;
      return true;
    });
  } else if (
    ((hour === 8 && minutes >= 1) || (hour === 9 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (index === 1 || index === 2 || index === 3) return false;
      return true;
    });
  } else if (
    ((hour === 9 && minutes >= 1) || (hour === 10 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (index === 1 || index === 2 || index === 3 || index === 4)
        return false;
      return true;
    });
  } else if (
    ((hour === 10 && minutes >= 1) || (hour === 11 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (
        index === 1 ||
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5
      )
        return false;
      return true;
    });
  } else if (
    ((hour === 11 && minutes >= 1) || (hour === 12 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (
        index === 1 ||
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5 ||
        index === 6
      )
        return false;
      return true;
    });
  } else if (
    ((hour === 12 && minutes >= 1) || (hour === 13 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (
        index === 1 ||
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5 ||
        index === 6 ||
        index === 7
      )
        return false;
      return true;
    });
  } else if (
    ((hour === 13 && minutes >= 1) || (hour === 14 && minutes === 0)) &&
    isToday
  ) {
    parsedOptions = allOptions.filter((item, index) => {
      if (
        index === 1 ||
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5 ||
        index === 6 ||
        index === 7 ||
        index === 8
      )
        return false;
      return true;
    });
  } else if (hour >= 14 && minutes >= 1) {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    minDatePicker = `${tomorrow
      .toLocaleString('sv', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .split(' ')[0]
      .split('/')
      .reverse()
      .join('-')}`;
  }

  if ($datePicker.value < $datePicker.min) {
    parsedOptions = [{ label: 'Select...', value: '' }];
  }

  return { parsedOptions, minDatePicker };
};

export const buildOptionsHtml = items => {
  return items
    .map(
      item => `
        <option value="${item.value}">${item.label}</option>
      `
    )
    .join('');
};
